import { canisterId } from "./declarations/backend"

// The Story Page is served by the backend canister itself, through the IC's
// HTTP gateway (docs/adr/0004), so its address is the backend's: on the local
// network, <id>.localhost:8000; on mainnet, the certified domain <id>.icp0.io.
// Under the dev stub there is no canister, and the links point at the same
// Roda app run by `rake story:dev`.
export const DEV_STORY_URL = "http://localhost:9292/"

export const backendOrigin = (id, network) => {
  if (!id || id === "dev-stub") return null
  return network === "ic" ? `https://${id}.icp0.io` : `http://${id}.localhost:8000`
}

export const storyUrl = (id, network) => (id === "dev-stub" ? DEV_STORY_URL : backendOrigin(id, network) && `${backendOrigin(id, network)}/`)

export const NETWORK = process.env.DFX_NETWORK || "local"

// Every [data-story-link] gets the address; [data-story-note] says where it goes.
export const linkStory = (root, id = canisterId, network = NETWORK) => {
  const url = storyUrl(id, network)
  // With no address, a link keeps the one the page gave it (the navbar's points
  // at the Features panel, which says why).
  root.querySelectorAll("[data-story-link]").forEach((a) => { if (url) a.href = url })
  root.querySelectorAll("[data-story-note]").forEach((el) => {
    el.textContent = !id ? " (no backend canister id: deploy first)"
      : id === "dev-stub" ? " (stubbed, no canister: run `rake story:dev`)" : ""
  })
}

document.addEventListener("DOMContentLoaded", () => linkStory(document))
